import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import {
  DATA_ROUTE,
  PASSWORD_ROUTE,
  ADDRESS_ROUTE,
} from '../../../constants/Routes';

import MyData from './MyData';

const DataRoutes = (props) => {
  const { mobile } = props;

  return (
    <Switch>
      <Route exact path={DATA_ROUTE}>
        <MyData mobile={mobile} path={DATA_ROUTE} />
      </Route>
      <Route exact path={PASSWORD_ROUTE}>
        <MyData mobile={mobile} path={PASSWORD_ROUTE} />
      </Route>
      <Route exact path={ADDRESS_ROUTE}>
        <MyData mobile={mobile} path={ADDRESS_ROUTE} />
      </Route>
    </Switch>
  );
};

DataRoutes.propTypes = {
  mobile: PropTypes.bool,
};

export default DataRoutes;
